import ReactDOM from 'react-dom';
import './assets/main.css';
import ApolloProvider from './ApolloProvider';

ReactDOM.render(ApolloProvider, document.getElementById('root'));
